<template>
  <div class="header_wrap timedeal-header">
    <div class="container">
      <div class="header_mall">
        <h1>
          <a href="/"><img src="../assets/images/mall_logo.svg" alt="" /></a>
        </h1>
        <div class="gnb_wrap">
          <ul class="mall_gnb">
            <li><a :href="isEmpty(idntCode) ? '/orderInquiry' : '/orderList'">주문내역</a></li>
          </ul>
          <div class="info">
            <a v-if="isEmpty(idntCode)" @click="login()">로그인</a>
            <a v-else @click="logout()">로그아웃</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="timedeal">
    <!-- 1. 메인 헤더 / 타이틀 영역 -->
    <div class="timedeal-content">
      <h2 class="page-title">TIME DEAL</h2>
      <p class="sub-title">매주, 단 {{ data.productList.length }}개의 상품만 타임특가</p>
    </div>

    <!-- [필수] 스티키 감지용 Sentinel -->
    <div ref="sentinel" class="sticky-sentinel"></div>

    <!-- 2. 스티키 영역 -->
    <section class="sticky-header" :class="{ 'is-stuck': isSticky }">
      <div class="timer-box">
        <div class="timer-top">
          <img src="../assets/images/clock.svg" alt="clock" />
          <span v-if="data.productList[0]?.productStatus?.status == 'before'">오픈까지</span>
          <span v-else>판매 종료까지</span>
          남은 시간
        </div>
        <div class="timer-display">
          <span class="days">{{ remaining.daysText }}</span>
          {{ remaining.hmsText }}
        </div>
        <div class="viewer-count">현재 {{ viewerCount }}명이 이 페이지를 보고있어요</div>
      </div>
    </section>

    <!-- 3. 메인 컨텐츠 영역 -->
    <main class="product-container">
      <article
        v-for="(item, idx) in data.productList"
        :key="item.goods_code || idx"
        class="product-item"
        :class="item?.productStatus?.status === 'before' ? 'upcoming' : ''"
      >
        <div v-if="item?.productStatus?.status === 'before'" class="thumbnail-wrapper">
          <div class="badge-group">
            <span class="badge dark">{{ item.discountValue }}% 할인</span>
          </div>

          <div class="single-image" @click="goProductDetail(item)">
            <div class="overlay-text">
              <p>{{ formatOpenDate(item.var2, item.open_time) }} 오픈 예정</p>
            </div>
            <img :src="item?.main_image_url[0]" alt="오픈예정상품" @error="replaceWithDefaultImg" />
          </div>
        </div>

        <div v-else class="thumbnail-wrapper">
          <div class="badge-group">
            <span class="badge purple">{{ item.discountValue }}% 할인</span>
            <span v-show="item.deliveryInfo.shipping_free_tble <= 0" class="badge shipping"
              >무료<br />배송</span
            >
          </div>
          <swiper
            :modules="modules"
            :slides-per-view="1.1"
            :centered-slides="true"
            :space-between="-30"
            :pagination="{ clickable: true }"
            class="my-swiper"
            @swiper="swiper => onSwiper(swiper, idx)"
            @slideChange="swiper => onSlideChange(swiper, idx)"
            @click="goProductDetail(item)"
          >
            <swiper-slide v-for="n in item.main_image_url" :key="n">
              <div class="slide-content">
                <img :src="n" alt="상품이미지" @error="replaceWithDefaultImg" />
              </div>
            </swiper-slide>
          </swiper>

          <button v-show="!isBeginningList[idx]" class="nav-btn prev" @click="prevSlide(idx)">
            <img src="../assets/images/arrow_right.svg" alt="prev" />
          </button>
          <button v-show="!isEndList[idx]" class="nav-btn next" @click="nextSlide(idx)">
            <img src="../assets/images/arrow_right.svg" alt="next" />
          </button>
        </div>

        <div class="info-wrapper">
          <div @click="goProductDetail(item)">
            <h3 class="prod-name">[{{ item.brand }}] {{ item.product_name }}</h3>
            <div class="price-info">
              <span class="origin-price">{{ _formatAmount(item.cost_price) }}원</span>
              <div class="final-price-row">
                <span class="discount-rate">{{ item.discountValue }}%</span>
                <span class="price">{{ _formatAmount(item.selling_price) }}원</span>
              </div>
            </div>
          </div>

          <button
            v-if="item?.productStatus?.status === 'before'"
            disabled
            class="btn btn-action"
            @click="openModal(item)"
          >
            {{ item.discountValue }}% 할인가로 바로구매
          </button>
          <button v-else class="btn btn-action primary" @click="openModal(item)">
            {{ item.discountValue }}% 할인가로 바로구매
          </button>
        </div>
      </article>

      <button class="btn btn-more" type="button" @click="goHome">
        전체보기 <img src="../assets/images/arrow_right.svg" alt="arrow" />
      </button>
    </main>

    <!-- 4. 구매 옵션 모달 -->
    <Transition name="fade">
      <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
        <Transition name="slide-up">
          <div v-if="isModalOpen" class="modal-content">
            <button class="btn-close" @click="closeModal">&times;</button>
            <h3 class="modal-title">옵션 선택</h3>

            <div class="option-form">
              <!-- 옵션 1 -->
              <div v-if="option.option1.length != 1" class="select-group">
                <label>옵션1 선택</label>
                <select
                  v-model="option.optionValue1"
                  :disabled="['before', 'passed'].includes(current.productStatus.status)"
                  class="input-form"
                  required
                  @change="handleChange"
                >
                  <option value="" disabled selected>선택해주세요</option>
                  <option v-for="(item, index) in option.option1" :key="index" :value="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>

              <!-- 옵션 2 -->
              <div v-if="current.products?.options_2?.length > 0" class="select-group">
                <label v-if="current.products?.options_1.length == 1">옵션 선택</label>
                <label v-else>옵션2 선택</label>
                <select
                  v-model="option.optionValue2"
                  class="input-form"
                  required
                  @change="handleChange2"
                >
                  <option value="" disabled selected>
                    {{ option.option1.length == 1 ? '옵션' : '옵션2' }}
                  </option>
                  <option v-for="(item, index) in option.option2" :key="index" :value="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>

              <div
                v-for="(item, index) in option.selectedOption"
                :key="`m-${index}`"
                class="option-select-modal"
              >
                <!-- 옵션명 + 삭제버튼 -->
                <div class="row">
                  <span>{{ item.label1 }} {{ item.label2 }}</span>
                  <button class="del-btn" @click="removeOption(index)">x</button>
                </div>

                <!-- 가격 + 수량조절 -->
                <div class="row bottom-row">
                  <div class="qty-box">
                    <button
                      class="btn-qty"
                      @click="item.cnt = (item.cnt ?? 1) <= 1 ? 1 : (item.cnt ?? 1) - 1"
                    >
                      -
                    </button>
                    <input v-model="item.cnt" type="number" class="qty-input" readonly />
                    <button class="btn-qty" @click="item.cnt = (item.cnt ?? 0) + 1">+</button>
                  </div>
                  <span class="price-text">
                    {{ _formatAmount((current.price + item.addAmount) * item.cnt) }}원
                  </span>
                </div>
              </div>
            </div>
            <button class="btn btn-action primary" @click="submitOrder">구매하기</button>
          </div>
        </Transition>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'TimeDealPage',
};
</script>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import img from '@/assets/images/Img.svg';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { ref, reactive, onMounted, onBeforeUnmount, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import api from '@/utils/api.js';
import { isEmpty } from 'lodash'; // lodash import 필요
import {
  _getRemainingTime,
  _getDiscountPercent,
  _formatAmount,
  _getPeriodStatus,
  _setStorageWithExpiry,
  _getStorageWithExpiry,
  _safeAtob,
  _safeBtoa,
} from '@/utils/common.js';

// --- [로그인/헤더 관련 변수] ---
const LOGIN_URL = 'https://tble.kr/login.php?url=mallLogin';
const loginPopup = ref(null);
const idntCode = ref('');
const isSeller = ref('');

const router = useRouter();
const route = useRoute();

// --- [타임딜 관련 변수] ---
const endAt = ref(null);
const remaining = ref({ daysText: '00', hmsText: '00:00:00' });
let timerId = null;

const modules = [Pagination];
const swiperInstances = ref([]);
const isBeginningList = ref([]);
const isEndList = ref([]);
const viewerCount = ref(0);
let intervalId = null;

const isSticky = ref(false);
const observer = ref(null);
const sentinel = ref(null);

const isModalOpen = ref(false);

const current = reactive({
  goodsCode: '',
  price: 0,
  products: {
    selling_price: 0,
    retail_price: 0,
    options_1: [],
    options_2: [],
    option_inven: [],
  },
  productStatus: { status: '', daysLeft: 0 },
});

const option = reactive({
  option1: [],
  option2: [],
  optionValue1: '',
  optionValue2: '',
  selectedOption: [],
});

const data = reactive({
  productList: {},
  selectProductInfo: {},
});

// --- [Lifecycle] ---
onMounted(() => {
  const queryId = route.query?.id;
  const idStr = Array.isArray(queryId) ? queryId[0] : queryId;

  if (idStr) {
    _setStorageWithExpiry('sId', String(idStr));
  }

  // 로그인 체크
  const id = _safeAtob(_getStorageWithExpiry('id'));
  const sy = _safeAtob(_getStorageWithExpiry('sy'));
  idntCode.value = id;
  isSeller.value = sy;
  window.addEventListener('message', handleMessage);

  // 타임딜 로직
  initViewerCount();
  intervalId = setInterval(updateViewerCount, 3000);
  initObserver();
  getData();
});

onBeforeUnmount(() => {
  window.removeEventListener('message', handleMessage);
  try {
    if (loginPopup.value && !loginPopup.value.closed) {
      loginPopup.value.close();
    }
  } catch (e) {
    console.log(e);
  }

  if (intervalId) clearInterval(intervalId);
  if (observer.value) observer.value.disconnect();
  document.body.style.overflow = '';
  if (timerId) clearInterval(timerId);
});

// --- [로그인/헤더 관련 함수] ---
function handleMessage(event) {
  const { type, mb_id, sy, hp } = event.data;
  console.log(event.data);

  if (type == 'tble') {
    if (loginPopup.value && !loginPopup.value.closed) {
      loginPopup.value.close();
    }

    _setStorageWithExpiry('id', _safeBtoa(mb_id));
    _setStorageWithExpiry('sy', _safeBtoa(sy));
    _setStorageWithExpiry('hp', _safeBtoa(hp));

    idntCode.value = mb_id;
  }
}

function login() {
  const currentUrl = encodeURIComponent(window.location.href);
  const loginUrl = `${LOGIN_URL}&uri=${currentUrl}`;

  try {
    if (loginPopup.value && !loginPopup.value.closed) {
      loginPopup.value.focus();
      return;
    }
  } catch (e) {
    console.log(e);
  }

  const width = 480;
  const height = 720;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${Math.max(0, left)}`,
    `top=${Math.max(0, top)}`,
    'resizable=yes',
    'scrollbars=yes',
  ].join(',');

  try {
    if (loginPopup.value && !loginPopup.value.closed) {
      loginPopup.value.location.href = loginUrl;
      loginPopup.value.focus();
      return;
    }
  } catch (e) {
    loginPopup.value = null;
  }

  loginPopup.value = window.open(loginUrl, 'tbleMallLogin', features);
  if (!loginPopup.value) {
    alert('팝업이 차단되었습니다.');
    return;
  }
  loginPopup.value.focus();
}

function logout() {
  ['id', 'sy', 'hp'].forEach(k => sessionStorage.removeItem(k));
  idntCode.value = null;
}

function goInquiry() {
  if (isEmpty(idntCode.value)) {
    alert('로그인이 필요한 서비스입니다.');
    return;
  }
  router.push('/inquiryList');
}

// --- [타임딜 로직 함수] ---
function goProductDetail(item) {
  const code = item?.goods_code;
  if (!code) return;
  router.push(`/productDetail/${code}`);
}

function goHome() {
  router.push('/');
}

function formatOpenDate(dateStr, openTime) {
  if (!dateStr) return '';
  const normalized = String(dateStr).trim().replace(/[./]/g, '-');
  const parts = normalized.split('-');
  if (parts.length < 3) return String(dateStr).trim();
  const y = Number(parts[0]);
  const m = Number(parts[1]);
  const d = Number(parts[2]);
  if (!y || !m || !d) return String(dateStr).trim();
  const dt = new Date(y, m - 1, d);
  const week = ['일', '월', '화', '수', '목', '금', '토'][dt.getDay()];
  const hourNum = Number(openTime);
  const hh = Number.isFinite(hourNum) ? String(hourNum).padStart(2, '0') : String(openTime);
  return `${m}/${d}(${week}) ${hh}:00`;
}

async function openModal(item) {
  if (item?.productStatus?.status && ['before', 'passed'].includes(item.productStatus.status)) {
    return;
  }
  data.selectProductInfo = item;
  const goodsCode = item?.goods_code || item?.code;
  if (!goodsCode) return;

  current.goodsCode = goodsCode;
  option.option1 = [];
  option.option2 = [];
  option.optionValue1 = '';
  option.optionValue2 = '';
  option.selectedOption = [];

  const hasOptionData =
    Array.isArray(item?.options_1) &&
    item.options_1.length > 0 &&
    Array.isArray(item?.option_inven) &&
    item.option_inven.length > 0;

  if (hasOptionData) {
    current.products = {
      selling_price: item?.selling_price || 0,
      retail_price: item?.retail_price || 0,
      options_1: item?.options_1 || [],
      options_2: item?.options_2 || [],
      option_inven: item?.option_inven || [],
    };
    current.productStatus = item?.productStatus || _getPeriodStatus(item);
    current.price = Number(item?.selling_price || 0);

    changeOption1();
    isModalOpen.value = true;
    document.body.style.overflow = 'hidden';
    return;
  }
}

function closeModal() {
  isModalOpen.value = false;
  document.body.style.overflow = '';
}

function submitOrder() {
  if (option.selectedOption.length <= 0) {
    alert('옵션을 선택해주세요.');
    return;
  }
  closeModal();
  router.push({
    path: '/payment',
    state: {
      item: JSON.stringify(data.selectProductInfo),
      option: JSON.stringify(option.selectedOption),
    },
  });
}

function getOption2ListByOption1(option1Idx) {
  return (current.products?.options_2 || []).filter(item => item.parent_idx === option1Idx);
}

function getInventoryByOptions(option1Idx, option2Idx) {
  const inven = current.products?.option_inven || [];
  if (!option2Idx) {
    return inven.find(inv => inv.parent_idx === option1Idx && !inv.child_idx);
  }
  return inven.find(inv => inv.parent_idx === option1Idx && inv.child_idx === option2Idx);
}

function changeOption1() {
  const optionList = (current.products?.options_1 || []).map(item => {
    const obj = getInventoryByOptions(item.idx, null);
    const amount = Number(obj?.option_add_price || 0);
    const amountStr = amount > 0 ? `(+${_formatAmount(amount)})` : '';
    return {
      value: item.idx,
      label: `${item.option_title} ${amountStr}`,
      amount,
    };
  });
  option.option1 = optionList;
  if (optionList.length === 1) {
    autoSelectOptionIfSingle();
  }
}

function autoSelectOptionIfSingle() {
  const only = option.option1[0];
  option.optionValue1 = only.value;
  if ((current.products?.options_2 || []).length > 0) {
    changeOption2();
    return;
  }
  const obj = getInventoryByOptions(only.value, null);
  option.selectedOption.push({
    label1: only.label,
    value1: only.value,
    addAmount: Number(only.amount || 0),
    label2: '',
    value2: '',
    invenIdx: obj?.idx || '',
    cnt: 1,
  });
  option.optionValue1 = '';
  option.optionValue2 = '';
}

function changeOption2() {
  option.option2 = getOption2ListByOption1(option.optionValue1).map(item => {
    const obj = getInventoryByOptions(option.optionValue1, item.idx);
    const amount = Number(obj?.option_add_price || 0);
    const amountStr = amount > 0 ? `(+${_formatAmount(amount)})` : '';
    return {
      value: item.idx,
      label: `${item.option_title} ${amountStr}`,
      amount,
    };
  });
}

function handleChange(event) {
  option.optionValue1 = event.target.value;
  if ((current.products?.options_2 || []).length > 0) {
    changeOption2();
    return;
  }
  const data1 = option.option1.find(it => it.value === option.optionValue1);
  const obj = getInventoryByOptions(data1?.value, null);
  if (option.selectedOption.find(it => it.value1 === data1?.value)) {
    alert('이미 선택된 옵션입니다.');
    option.optionValue1 = '';
    option.optionValue2 = '';
    if (option.option1.length == 1) {
      autoSelectOptionIfSingle();
    }
    return;
  }
  option.selectedOption.push({
    label1: data1?.label || '',
    value1: data1?.value || '',
    addAmount: Number(data1?.amount || 0),
    label2: '',
    value2: '',
    invenIdx: obj?.idx || '',
    cnt: 1,
  });
  option.optionValue1 = '';
  option.optionValue2 = '';

  requestAnimationFrame(() => event.target.blur());
}

function handleChange2(event) {
  const idx = event.target.value;
  const data1 = option.option1.find(it => it.value === option.optionValue1);
  const data2 = option.option2.find(it => it.value === idx);
  const obj = getInventoryByOptions(data1?.value, data2?.value);
  if (option.selectedOption.find(it => it.value1 === data1?.value && it.value2 === data2?.value)) {
    alert('이미 선택된 옵션입니다.');
    option.optionValue1 = '';
    option.optionValue2 = '';
    return;
  }
  option.selectedOption.push({
    label1: data1?.label || '',
    value1: data1?.value || '',
    label2: data2?.label || '',
    value2: data2?.value || '',
    invenIdx: obj?.idx || '',
    addAmount: Number(data2?.amount || 0),
    cnt: 1,
  });
  option.optionValue1 = '';
  option.optionValue2 = '';
  option.option2 = [];
  if (option.option1.length == 1) {
    autoSelectOptionIfSingle();
  }

  requestAnimationFrame(() => event.target.blur());
}

function removeOption(index) {
  option.selectedOption.splice(index, 1);
}

// --- [Observer & Swiper & API] ---
function initObserver() {
  const el = sentinel.value;
  observer.value = new IntersectionObserver(
    ([entry]) => {
      isSticky.value = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    },
    { threshold: 0 },
  );
  if (el) observer.value.observe(el);
}

function onSwiper(swiper, idx) {
  swiperInstances.value[idx] = swiper;
  checkArrowStatus(swiper, idx);
}

function onSlideChange(swiper, idx) {
  checkArrowStatus(swiper, idx);
}

function checkArrowStatus(swiper, idx) {
  isBeginningList.value[idx] = swiper.isBeginning;
  isEndList.value[idx] = swiper.isEnd;
}

function prevSlide(idx) {
  const inst = swiperInstances.value[idx];
  if (inst) inst.slidePrev();
}

function nextSlide(idx) {
  const inst = swiperInstances.value[idx];
  if (inst) inst.slideNext();
}

function initViewerCount() {
  viewerCount.value = Math.floor(Math.random() * (200 - 100 + 1)) + 100;
}

function updateViewerCount() {
  const change = Math.floor(Math.random() * 11) - 5;
  let next = viewerCount.value + change;
  if (next < 50) next = 50;
  if (next > 300) next = 300;
  viewerCount.value = next;
}

async function getData() {
  const param = {
    mode: 'marketTime',
    rows: 2,
    page: 1,
    type: 'G',
  };
  const response = await api.post('/goods.php', param);
  if (response.data.result == 'SUCCESS') {
    const list = Array.isArray(response.data.data) ? response.data.data : [];
    const enriched = await Promise.all(
      list.map(async item => {
        const goodsCode = item?.goods_code || item?.code;
        const discountValue = _getDiscountPercent(item?.cost_price, item?.selling_price);
        const productStatus = _getPeriodStatus(item);
        if (!goodsCode) return { ...item, deliveryInfo: null, discountValue, productStatus };
        try {
          const deliveryInfo = await getDeliveryFee(goodsCode);
          return { ...item, deliveryInfo, discountValue, productStatus };
        } catch (e) {
          return { ...item, deliveryInfo: null, discountValue, productStatus };
        }
      }),
    );
    data.productList = enriched;
    isBeginningList.value = enriched.map(() => true);
    isEndList.value = enriched.map(() => false);
    swiperInstances.value = enriched.map(() => null);
    setEndAtFromVar3(
      data.productList[0].productStatus.status == 'before'
        ? `${data.productList[0].var2} ${data.productList[0].open_time}:00:00`
        : `${data.productList[0].var3} 23:59:59`,
    );
    startTimer();
  } else {
    alert('상품 정보를 불러오지 못했습니다. 다시 시도해주세요.');
  }
}

const getDeliveryFee = async goodsCode => {
  const response = await api.post('/auth.php', {
    goods_code: goodsCode,
  });
  return response?.data?.data || null;
};

function setEndAtFromVar3(var3) {
  const endStr = (var3 || '').toString().trim().replace(/[./]/g, '-');
  if (!endStr) {
    endAt.value = null;
    remaining.value = { daysText: '0일', hmsText: '00:00:00' };
    return;
  }
  endAt.value = new Date(endStr);
  remaining.value = _getRemainingTime(endAt.value);
}

function startTimer() {
  if (timerId) clearInterval(timerId);
  timerId = setInterval(() => {
    if (!endAt.value) return;
    remaining.value = _getRemainingTime(endAt.value);
  }, 1000);
}

function replaceWithDefaultImg(e) {
  e.target.onerror = null;
  e.target.src = img;
}
</script>

<style scoped></style>
